export const manufacturerList = [
  {
    id: 1,
    title: "Nhà sản xuất",
    value: "name",
  },
  {
    id: 2,
    title: "Xuất xứ",
    value: "origin",
  },
];
